<template>
  <el-dialog :title="dtitle" :visible="dialogFormVisible" :before-close="handleClose" class="dialog-form">
    <table-form :dataSource="myDataSource" ref="form" :tableData="formData" :disable="true"></table-form>
    <div class="upload">
      <el-table :data="dataUp" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column prop="title" label="材料名称" width="150"></el-table-column>
        <el-table-column prop="oldFile" label="附件名称" width="auto"></el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile ? false : true"
              @click="downFile(scope.row)"
              style="font-size: 14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from 'common/components/form/tableForm'
import { step3 } from '@/conf/newAgency'
import { getInvestorDetail, downLoadCommon, institutionDownLoadCommon } from 'common/js/api'

export default {
  components: {
    TableForm
  },

  props: ['dialogOnes', 'dtitle', 'tableData', 'dataSource', 'fundType'], //falg判断是联系人、负责人

  data() {
    return {
      dialogFormVisible: false,
      myDataSource: {},
      formData: {},
      dataUp: []
    }
  },

  methods: {
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = fileData[1].split(".");

      //       const index = row.newFile.lastIndexOf("/");
      //       const suffix = row.newFile.slice(index + 1).split(".");
      //       const filePath = row.newFile.slice(0, index);
      // console.log(filePath, suffix[1], row.oldFile, suffix[0]);
      //       await downLoadCommon(filePath, suffix[1], row.oldFile, suffix[0]);

      const filePath = row.newFile
      const fileName = row.oldFile
      console.log('@@row', row)
      console.log('@@filePath', filePath)
      console.log('@@fileName', fileName)
      const params = {
        filePath: filePath,
        fileName: fileName
      }
      await institutionDownLoadCommon(params)
      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
    },

    handleClose() {
      this.dialogFormVisible = false
      this.$emit('closeDialog1')
    },

    async setInvestor(id) {
      const { result } = await getInvestorDetail(id)
      this.dataUp = []
      if (this.fundType == '持股平台') {
        this.dataUp = [
          {
            title: '营业执照/身份证',
            oldFile: result.investorIdentityFileOrginName,
            newFile: result.investorIdentityFileStorePath
          }
        ]
      } else if (this.fundType == '自有资金投资类企业') {
        this.dataUp = [
          {
            title: '承诺出资额佐证材料',
            oldFile: result.admitCapitalFileOrginName,
            newFile: result.admitCapitalFileStorePath
          },
          {
            title: '认缴出资能力佐证材料',
            oldFile: result.qualifiedInvestorFileOrignName,
            newFile: result.qualifiedInvestorFileStorePath
          },
          {
            title: '已缴出资额佐证材料',
            oldFile: result.paidCapitalFileOrginName,
            newFile: result.paidCapitalFileStorePath
          },
          {
            title: '出资人备案承诺书',
            oldFile: result.investorPromiseOrginName,
            newFile: result.investorPromiseStorePath
          }
        ]
      } else {
        this.dataUp = [
          {
            title: '营业执照/身份证',
            oldFile: result.identityFileOrignName,
            newFile: result.identityFileStorePath
          },
          {
            title: '合格投资者佐证材料',
            oldFile: result.qualifiedInvestorFileOrignName,
            newFile: result.qualifiedInvestorFileStorePath
          },
          {
            title: '资本认缴承诺函',
            oldFile: result.promiseOrignName,
            newFile: result.promiseOrignName
          }
        ]
      }

      // this.dataUp = [
      //   {
      //     title: "营业执照/身份证",
      //     oldFile: result.identityFileOrignName,
      //     newFile: result.identityFileStorePath,
      //   },
      //   {
      //     title: "资本认缴承诺",
      //     oldFile: result.captalPaidOrignName,
      //     newFile: result.captalPaidStorePath,
      //   },
      //   {
      //     title: "业务规范承诺函",
      //     oldFile: result.bussinessPermissionOrignName,
      //     newFile: result.bussinessPermissionStorePath,
      //   },
      // ];
      // if (result.institutionCode.slice(0, 2) != "GL") {
      //   this.dataUp.push({
      //     title: "合格投资者证明",
      //     oldFile: result.qualifiedInvestorFileOrignName,
      //     newFile: result.qualifiedInvestorFileStorePath,
      //   });
      // }
    },
    setDownLoad(id) {
      if (this.dtitle.includes('出资人')) {
        this.setInvestor(id)
      }
      // else if(['联系人详情','财务负责人详情'].includes(this.dtitle)) {
      //   this.setLink(id)
      // }
      // else if(['法定代表人详情','合规风控负责人详情'].includes(this.dtitle)) {
      //   // this.setLegal(id)
      // }
    }
  },

  watch: {
    dialogOnes(newValue) {
      console.log('dialogOnes触发了 -- ', newValue)
      this.dialogFormVisible = newValue
    },
    tableData: {
      handler(newValue) {
        console.log('tableData触发了 -- ', newValue)
        this.setDownLoad(newValue.id)
        this.formData = newValue
      },
      deep: true
    },
    dataSource: {
      handler(newValue) {
        console.log('dataSource触发了 -- ', newValue)
        this.myDataSource = newValue
      },
      deep: true
    }
  }
}
</script>

